interface Props {
  className?: string;
}
export const OpenInNewTabIcon = ({ className }: Props) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M1.83333 12.0859C1.46667 12.0859 1.15278 11.9554 0.891667 11.6943C0.630556 11.4332 0.5 11.1193 0.5 10.7526V1.41927C0.5 1.0526 0.630556 0.738715 0.891667 0.477604C1.15278 0.216493 1.46667 0.0859375 1.83333 0.0859375H6.5V1.41927H1.83333V10.7526H11.1667V6.08594H12.5V10.7526C12.5 11.1193 12.3694 11.4332 12.1083 11.6943C11.8472 11.9554 11.5333 12.0859 11.1667 12.0859H1.83333ZM4.96667 8.5526L4.03333 7.61927L10.2333 1.41927H7.83333V0.0859375H12.5V4.7526H11.1667V2.3526L4.96667 8.5526Z"
        fill="var(--swapper-primary-color)"
      />
    </svg>
  );
};
